/**
 * @file 选择城市/门店/时间
 */

import React, {Component} from 'react';
import {SAVE_START_TIME, SAVE_END_TIME} from '../../redux/actions/homeAction';
import {parseStateToSearch} from '../../util/util.js';
import moment from 'moment';
import {List, Calendar, Button, Toast} from 'antd-mobile';
import {connect} from 'react-redux';
import {Http, urls} from '../../api/index';
import './index.scss';
const Item = List.Item;
const now = new Date(Date.now() + 2 * 60 * 60 * 1000);
const weekday = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

class Search extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            // 下单时间与取车时间的最小时间间隔（单位：小时）
            createOrderMinHours: 2,
            // 超过几小时就算1整天
            hourExceedsThresholdToOneDay: 4,
            dateDiffNum: 2
        };
    }

    componentDidMount() {
        this.getOrderConfigs();
    }

    getOrderConfigs() {
        let url = urls.getOrderConfigs;
        Http.post({url}).then(res => {
            let data = res.data;
            this.setState({
                createOrderMinHours: data.createOrderTimeAndGaincarTimeMinHours,
                hourExceedsThresholdToOneDay: data.hourExceedsThresholdToOneDay
            });
        });
    }

    setDateDiffNum(startTime, endTime) {
        let sTime = `${startTime.year}/${startTime.month}/${startTime.day} ${startTime.hours}:${startTime.minutes}`;
        let eTime = `${endTime.year}/${endTime.month}/${endTime.day} ${endTime.hours}:${endTime.minutes}`;
        let date1 = new Date(sTime);
        let date2 = new Date(eTime);
        let date = (date2.getTime() - date1.getTime()) / (1000 * 60 * 60);

        let {hourExceedsThresholdToOneDay} = this.state;
        let num = date % 24 < hourExceedsThresholdToOneDay ? 0 : 1;
        date = parseInt(date / 24) + num;

        this.setState({
            dateDiffNum: date
        });
    }

    getDateDiffNum(sTime, eTime) {
        let date1 = new Date(sTime);
        let date2 = new Date(eTime);
        let yuNum = 0;

        // 总小时
        let dateDiffNum = (date2.getTime() - date1.getTime()) / (1000 * 60 * 60);
  
        // 取整天
        let zNum = parseInt(dateDiffNum / 24);
  
        if (zNum > 0) {
            // 小于4小时的算一天
            yuNum = dateDiffNum % 24 < 4 ? 0 : 1;
        }
        // 总天数
        dateDiffNum = zNum + yuNum;
  
        if (Number(dateDiffNum) >= 1) {
            this.setState({
                dateDiffNum: parseInt(dateDiffNum)
            });
            return true;
        }
        return false;
    }

    docheckStartHours(startTime) {
        let currentHours = Date.now();
        let hours = new Date(startTime).getTime();
        let {createOrderMinHours} = this.state;
        return (hours - currentHours) > createOrderMinHours * 60 * 60 * 1000;
    }

    // 校验所选时间是否在门店营业时间范围内
    doCheckBusinessHours(startTime, endTime) {
        let s = new Date();
        let e = new Date();
        let gaiStartStore = new Date();
        let gaiEndStore = new Date();
        let getStartStore = new Date();
        let getEndStore = new Date();
        let {
            gaiStoreInfo,
            getStoreInfo
        } = this.props;

        s.setHours(startTime.getHours());
        s.setMinutes(startTime.getMinutes());
        e.setHours(endTime.getHours());
        e.setMinutes(endTime.getMinutes());
        gaiStartStore.setHours(gaiStoreInfo.businessHours.split('-')[0].split(':')[0]);
        gaiStartStore.setMinutes(gaiStoreInfo.businessHours.split('-')[0].split(':')[1]);
        gaiEndStore.setHours(gaiStoreInfo.businessHours.split('-')[1].split(':')[0]);
        gaiEndStore.setMinutes(gaiStoreInfo.businessHours.split('-')[1].split(':')[1]);
  
        getStartStore.setHours(getStoreInfo.businessHours.split('-')[0].split(':')[0]);
        getStartStore.setMinutes(getStoreInfo.businessHours.split('-')[0].split(':')[1]);
        getEndStore.setHours(getStoreInfo.businessHours.split('-')[1].split(':')[0]);
        getEndStore.setMinutes(getStoreInfo.businessHours.split('-')[1].split(':')[1]);
        if (s.getTime() < gaiStartStore.getTime() || s.getTime() > gaiEndStore.getTime()) {
            Toast.info('取车时间不在门店经营时间范围内，请重新选择！');
            return false;
        }
        else if (e.getTime() < getStartStore.getTime() || e.getTime() > getEndStore.getTime()) {
            Toast.info('还车时间不在门店经营时间范围内，请重新选择！');
            return false;
        }
        return true;
    }

    onCancel = () => {
        this.setState({
            show: false
        });
    }

    onConfirm = (startTime, endTime) => {
        let checkDateRange = this.getDateDiffNum(startTime, endTime);
        let checkHours = this.docheckStartHours(startTime);
        let checkBusinessHours = this.doCheckBusinessHours(startTime, endTime);
        let {createOrderMinHours} = this.state;
        if (!checkDateRange) {
            Toast.info('租期至少为一天，请重新选择');
            return false;
        }
        if (!checkHours) {
            Toast.info(`预约取车时间距离当前时间小于${createOrderMinHours}小时不能下单`);
            return false;
        }
        if (!checkBusinessHours) {
            return false;
        }

        let startTimeObj = {
            year: startTime.getFullYear(),
            month: startTime.getMonth() + 1,
            day: startTime.getDate(),
            week: weekday[startTime.getDay()],
            hours: startTime.getHours(),
            minutes: startTime.getMinutes()
        };

        let endTimeObj = {
            year: endTime.getFullYear(),
            month: endTime.getMonth() + 1,
            day: endTime.getDate(),
            week: weekday[endTime.getDay()],
            hours: endTime.getHours(),
            minutes: endTime.getMinutes()
        };

        this.props.dispatch(SAVE_START_TIME({startTime: startTimeObj}));
        this.props.dispatch(SAVE_END_TIME({endTime: endTimeObj}));

        this.setState({
            show: false
        });
    }

    gotoChooseCity = cityCode => {
        const {history} = this.props;
        history.push({
            pathname: '/city',
            search: parseStateToSearch({cityclasses: cityCode})
        });
    }

    gotoChooseStore = cityCode => {
        const {history} = this.props;
        let params = '';
        if (+cityCode === 1) {
            params = {...this.props.gaiCityInfo};
        } else {
            params = {...this.props.getCityInfo};
        }
        history.push({
            pathname: '/stores',
            search: parseStateToSearch({cityclasses: cityCode, ...params, pathname: history.location.pathname})
        });
    }

    pad = time => time >= 10 ? time : `0${time}`;

    // 首页点击立即租车
    doSelectCar() {
        const {history} = this.props;
        let {
            gaiCityInfo,
            getCityInfo,
            gaiStoreInfo,
            getStoreInfo,
            startTime,
            endTime
        } = this.props;
        let url = urls.bookingOpenTimeCheck;
        let sTime = `${startTime.year}${this.pad(startTime.month)}${this.pad(startTime.day)}${this.pad(startTime.hours)}${this.pad(startTime.minutes)}00`;
        let eTime = `${endTime.year}${this.pad(endTime.month)}${this.pad(endTime.day)}${this.pad(endTime.hours)}${this.pad(endTime.minutes)}00`;
        let sCheckBusinessHours = `${startTime.year}/${startTime.month}/${startTime.day} ${this.pad(startTime.hours)}:${this.pad(startTime.minutes)}`;
        let eCheckBusinessHours = `${endTime.year}/${endTime.month}/${endTime.day} ${this.pad(endTime.hours)}:${this.pad(endTime.minutes)}`;
        let checkBusinessHours = this.doCheckBusinessHours(new Date(sCheckBusinessHours), new Date(eCheckBusinessHours));
        if (!checkBusinessHours) {
            return false;
        }

        let params = {
            orderProdType: 'D',
            bookingGaincarTimeStr: sTime,
            bookingGaincarStoreId: gaiStoreInfo.storeId,
            bookingBackcarTimeStr: eTime
        };
        let {hourExceedsThresholdToOneDay, dateDiffNum} = this.state;
        Http.post({url, data: params}).then(res => {
            if (res.code === 0) {
                history.push({
                    pathname: '/carList',
                    search: parseStateToSearch({
                        hourExceedsThresholdToOneDay,
                        gaiCityName: gaiCityInfo.cityName,
                        getCityName: getCityInfo.cityName,
                        gaiCityId: gaiCityInfo.cityId,
                        getCityId: getCityInfo.cityId,
                        gaiStoreId: gaiStoreInfo.storeId,
                        gaicoordinatePoint: `${gaiStoreInfo.longitude},${gaiStoreInfo.latitude}`,
                        getStoreId: getStoreInfo.storeId,
                        gaiStoreName: gaiStoreInfo.storeName,
                        getStoreName: getStoreInfo.storeName,
                        getcoordinatePoint: `${getStoreInfo.longitude},${getStoreInfo.latitude}`,
                        startTime: `${startTime.month}-${startTime.day} ${this.pad(startTime.hours)}:${this.pad(startTime.minutes)}`,
                        endTime: `${endTime.month}-${endTime.day} ${this.pad(endTime.hours)}:${this.pad(endTime.minutes)}`,
                        sTime: `${startTime.year}-${this.pad(startTime.month)}-${this.pad(startTime.day)} ${this.pad(startTime.hours)}:${this.pad(startTime.minutes)}:00`,
                        eTime: `${endTime.year}-${this.pad(endTime.month)}-${this.pad(endTime.day)} ${this.pad(endTime.hours)}:${this.pad(endTime.minutes)}:00`,
                        dateDiffNum
                    })
                });
            } else {
                Toast.info(res.msg);
            }
        });
    }

    render() {
        let {
            gaiCityInfo,
            getCityInfo,
            gaiStoreInfo,
            getStoreInfo,
            startTime,
            endTime
        } = this.props;
        return (
            <div>
                <div className="select-box">
                    <List renderHeader={() => '取车门店'} className="my-list">
                        <Item multipleLine>
                            <div className="search-city" onClick={() => this.gotoChooseCity('1')}>{gaiCityInfo.cityName}</div>
                            <div className="search-store" onClick={() => this.gotoChooseStore('1')}>{gaiStoreInfo.storeName}</div>
                        </Item>
                    </List>
                    <List renderHeader={() => '还车门店'} className="my-list">
                        <Item multipleLine>
                            <div className="search-city" onClick={() => this.gotoChooseCity('2')}>{getCityInfo.cityName}</div>
                            <div className="search-store" onClick={() => this.gotoChooseStore('2')}>{getStoreInfo.storeName}</div>
                        </Item>
                    </List>
                    <div className="date-select">
                        <div
                            className="start-datetime"
                            onClick={() => {
                                this.setState({
                                    show: true
                                });
                            }}
                        >
                            <div className="search-date">{startTime.month}月{startTime.day}日</div>
                            <div className="search-time">
                                {startTime.week}
                                {this.pad(startTime.hours)}:{this.pad(startTime.minutes)}
                            </div>
                        </div>
                        <div className="search-date-num">
                            <div>{this.state.dateDiffNum}天</div>
                            <div className="search-line"></div>
                        </div>
                        <div
                            className="end-datetime"
                            onClick={() => {
                                this.setState({
                                    show: true
                                });
                            }}
                        >
                            <div className="search-date">{endTime.month}月{endTime.day}日</div>
                            <div className="search-time">
                                {endTime.week}
                                {this.pad(endTime.hours)}:{this.pad(endTime.minutes)}
                            </div>
                        </div>
                    </div>
                    <Button type="warning" className="search-btn" onClick={() => this.doSelectCar()}>立即租车</Button>
                </div>
                <Calendar
                    pickTime={true}
                    visible={this.state.show}
                    onCancel={this.onCancel}
                    onConfirm={this.onConfirm}
                    defaultDate={now}
                    minDate={new Date(`${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`)}
                    maxDate={new Date(+now + (8.64e7 * 89))}
                    defaultValue={[
                        new Date(`${startTime.year}/${startTime.month}/${startTime.day} ${startTime.hours}:${startTime.minutes}`),
                        new Date(`${endTime.year}/${endTime.month}/${endTime.day} ${endTime.hours}:${endTime.minutes}`)
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    let params = state.homeReducer;
    return {
        gaiCityInfo: params.gaiCityInfo,
        getCityInfo: params.getCityInfo,
        gaiStoreInfo: params.gaiStoreInfo,
        getStoreInfo: params.getStoreInfo,
        startTime: params.startTime,
        endTime: params.endTime
    };
};

Search = connect(mapStateToProps)(Search);

export default Search;